import web from '@/web';
import Location from '@/models/Location.ts';
import CheckoutOption from '@/models/CheckoutOption.ts';

const REFRESH_TIME_MILLIS = 5 * 60 * 1000;  // 5 minutes

let mutations = {
  setLocations(state, locations) {
    state.list = locations;
  },
  setNodes(state, { location, type, nodes }) {
    location.lastLoadDate[type] = new Date();
    location.nodes[type] = nodes;
  },
};

let actions = {
  async loadLocationsWithAllNodes({ commit, state }) {
    if (!state.lastLoaded || (new Date().getTime() - state.lastLoaded.getTime()) > REFRESH_TIME_MILLIS) {
      state.lastLoaded = new Date();

      const response = await web.getAllNodes();

      // Combine all locations into a super-list, but add metatags telling if it's owned, accessed, etc.
      var allLocations = [
        ...response.data.owned.map((owned) => new Location(owned, 'owned', response.data.ownedNodes[owned.id])),
        ...response.data.accesses.map((accesses) => new Location(accesses.location, 'access', response.data.accessesNodes[accesses.location.id])),
        ...response.data.unapproved.map((unapproved) => new Location(unapproved, 'unapproved', response.data.unapprovedNodes[unapproved.id])),
        ...response.data.pending.map((pending) => new Location(pending, 'pending', response.data.pendingNodes[pending.id])),
      ];

      state.checkoutOptions = response.data.checkoutOptions;

      commit('setLocations', allLocations);
    }
    // TODO start reload timer
  },
};

const purchase = {
  state: {
    list: [],
    lastLoaded: null,

    // The available checkout options to choose from
    checkoutOptions: [],

    // The user's currently-chosen order options
    orderOptions: [],
  },
  actions,
  mutations,
  getters: {
  }
};
export default purchase;
